import { createBrowserRouter, Navigate } from 'react-router-dom';
import { publicRoutes, scopedRoutes } from '@/app/routes';
import { ShellLayout } from '@/features/shell/ShellLayout';
import { LandingPage } from '@/features/auth/LandingPage';
import { LoginPage } from '@/features/auth/LoginPage';
import { SelectScopePage } from '@/features/auth/SelectScopePage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { ShipmentsPage } from '@/features/shipments/ShipmentsPage';
import { ScanPage } from '@/features/scan/ScanPage';
import { ConsolidationsPage } from '@/features/consolidations/ConsolidationsPage';
import { DeliveriesPage } from '@/features/deliveries/DeliveriesPage';
import { CustomersPage } from '@/features/customers/CustomersPage';
import { WarehousesPage } from '@/features/warehouses/WarehousesPage';
import { DriversPage } from '@/features/drivers/DriversPage';
import { TariffsPage } from '@/features/tariffs/TariffsPage';
import { TrackPage } from '@/features/portal/TrackPage';
import { PortalLoginPage } from '@/features/portal/PortalLoginPage';
import { PortalPage } from '@/features/portal/PortalPage';

export const router = createBrowserRouter([
  { path: publicRoutes.landing, element: <LandingPage /> },
  { path: publicRoutes.login, element: <LoginPage /> },
  { path: publicRoutes.selectScope, element: <SelectScopePage /> },
  { path: publicRoutes.track, element: <TrackPage /> },
  { path: `${publicRoutes.track}/:trackingNo`, element: <TrackPage /> },
  { path: publicRoutes.portalLogin, element: <PortalLoginPage /> },
  { path: publicRoutes.portal, element: <PortalPage /> },
  {
    path: '/:tenantId/:companyId',
    element: <ShellLayout />,
    children: [
      { index: true, element: <Navigate to={scopedRoutes.dashboard} replace /> },
      { path: scopedRoutes.dashboard, element: <DashboardPage /> },
      { path: scopedRoutes.shipments, element: <ShipmentsPage /> },
      { path: scopedRoutes.scan, element: <ScanPage /> },
      { path: scopedRoutes.consolidations, element: <ConsolidationsPage /> },
      { path: scopedRoutes.deliveries, element: <DeliveriesPage /> },
      { path: scopedRoutes.customers, element: <CustomersPage /> },
      { path: scopedRoutes.warehouses, element: <WarehousesPage /> },
      { path: scopedRoutes.drivers, element: <DriversPage /> },
      { path: scopedRoutes.tariffs, element: <TariffsPage /> },
    ],
  },
  { path: '*', element: <Navigate to={publicRoutes.login} replace /> },
]);
